var jade = require("/data/node/puzzle-author/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div id=\"player_game_input_pass_info_chart\" style=\"width: 750px;height:480px;\"></div>");;return buf.join("");
}